import { OktaAuth } from '@okta/okta-auth-js';

import { getAccessToken, getAnalyticsObj, getIdToken, getUser } from './oktaAuthUtils';
import { oktaConfig } from './oktaconfig';

const oktaAuth = new OktaAuth(oktaConfig);
oktaAuth.start();

oktaAuth.getAccessToken = () => getAccessToken(oktaAuth);
oktaAuth.getIdToken = () => getIdToken(oktaAuth);
oktaAuth.getUser = () => getUser(oktaAuth);
oktaAuth.getAnalyticsObj = () => getAnalyticsObj(oktaAuth);

export default oktaAuth;
